import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Stack,
    Text,
    Switch,
    HStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const AdvancedTransferField = ({
    errors,
    values,
    touched,
    darkMode,
    isDisabled = false,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{
                margin: '0 !important',
                '& svg': {
                    mt: '8px!important',
                },
            }}
            isInvalid={
                !!errors.useAdvancedTransfer && touched.useAdvancedTransfer
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Advanced Transfer
                    </FormLabel>
                    <Text
                        sx={{
                            ...descriptionStyling,
                            color: darkMode ? 'gray.100' : '#757575',
                        }}
                        maxW={250}>
                        Microsoft Teams Only. Enables the correct free/busy
                        status following call transfer by a Teams user, to
                        another Teams user.
                    </Text>
                </Box>
                <Field name="useAdvancedTransfer">
                    {({ field, form: { setFieldValue } }) => (
                        <Box
                            flex="1"
                            sx={{
                                paddingTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <HStack spacing={3} alignItems="center">
                                <Switch
                                    {...field}
                                    id="useAdvancedTransfer"
                                    isChecked={values?.useAdvancedTransfer}
                                    isDisabled={isDisabled}
                                    onChange={(e) => {
                                        setFieldValue(
                                            'useAdvancedTransfer',
                                            e.target.checked,
                                        );
                                    }}
                                    size="md"
                                />
                                <Text
                                    className="!mb-2"
                                    fontSize="sm"
                                    color={darkMode ? 'gray.100' : 'gray.700'}
                                    fontWeight="semibold">
                                    {values?.useAdvancedTransfer
                                        ? 'Enabled'
                                        : 'Disabled'}
                                </Text>
                            </HStack>

                            {errors?.useAdvancedTransfer && (
                                <FormErrorMessage fontSize="sm" mt={1}>
                                    {errors?.useAdvancedTransfer}
                                </FormErrorMessage>
                            )}
                        </Box>
                    )}
                </Field>

                {isHovered && (
                    <FieldToolTip
                        label="When enabled, TRS provides valid status, even where a transfer takes place via an auto attendant or call queue"
                        ariaLabel="advanced-transfer-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AdvancedTransferField;
